export const OPERATOR_ROUTES_LIST = 'operator-routes-list'
export const ROUTE_SERVICES = 'driver-details-route-services'
export const CLEAR_DRIVER_DETAILS = 'clear-driver-details'
